/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/no-children-prop */
import React, { useEffect, useState } from 'react';
import { Box, Button, Container, Grid, Modal, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { GoogleMap, useJsApiLoader, MarkerF } from '@react-google-maps/api';

import axios from 'axios';
import useStyles from '../../../../assets/styles/pages/Address';

// import svg
import { ReactComponent as IconLocation } from '../../../../assets/images/svg/address_list/icon_local.svg';
import { ReactComponent as IconInfo } from '../../../../assets/images/svg/utils/info.svg';

// import img
import { useSignInContext } from '../../../../providers/use-signin';
import { useLoadingContext } from '../../../../providers/use-loading';
import { ItypeReturnApi } from '../../../../helpers/utils/TypeReturnApi';
import { api } from '../../../../services';
import Header from '../../../../components/Header';
import FooterMenuMain from '../../../../components/FooterMenuMain';
import {
  getStorege,
  removeStorege,
  saveStorege,
} from '../../../../helpers/db_storage';

const containerStyle = {
  width: '100%',
  height: '100%',
};

const styleModal = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  bgcolor: 'background.paper',
  border: '2px solid #ffffff',
  boxShadow: 24,
  outline: 'none',
};

const AddressMap: React.FC = () => {
  const { params, id_shop }: any = useParams();
  const navigate = useNavigate();
  const classeStyle = useStyles();
  const { search } = useLocation();
  const variavelGet = new URLSearchParams(search);
  const getUser = variavelGet.get('user');

  const { signing, data, signingOut } = useSignInContext();
  const { createloading } = useLoadingContext();
  const [addressa, setAddressa] = useState<any>();
  const [openInfoModal, setOpenInfoModal] = useState<boolean>(false);
  const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false);
  const [textModal, setTextModal] = useState({
    title: '',
    description: '',
  });
  const [location, setLocation] = useState({
    lat: 0,
    lng: 0,
  });

  const handleToPage = (url: string) => {
    return navigate(url, { replace: true });
  };

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyBOVT_nJ4PZNvAoOLPIJu7Ho-aAYbwXPis',
  });

  const handleNewLocation = (marker: any) => {
    setLocation({
      lat: marker.latLng.lat(),
      lng: marker.latLng.lng(),
    });
  };

  const checkLatLong = async (idCidade: any, lat: any, lng: any) => {
    try {
      const result: ItypeReturnApi =
        await api.apiMaisdelivery.address.checkLatLong({
          nr_operacao: 71,
          idCidade,
          latitude: lat,
          longitude: lng,
        });

      return result.data?.retorno;
    } catch (error) {
      toast.error('Ocorreu um erro ao verificar sua localização.');
      return '';
    }
  };

  const getLatLongGoogleMaps = async (address: any) => {
    const {
      dsCidade,
      idCidade,
      dsEstado,
      dsNomeRua,
      nrNumeroCasa,
      nrLatitudeCidade,
      nrLongitudeCidade,
    } = address;

    const result = await axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json?sensor=true&language=pt&address=Brasil,${dsEstado}%20,${dsCidade},${dsNomeRua}%20${nrNumeroCasa}&sensor=false&key=AIzaSyCScihQOmM01aiHdsXCWSEogbmJ1GKT0EY`,
    );

    if (result.data.status === 'OK') {
      const resultCheckLatLong = await checkLatLong(
        idCidade,
        result.data.results[0].geometry.location.lat,
        result.data.results[0].geometry.location.lng,
      );

      if (resultCheckLatLong == 'NOK') {
        setLocation({
          lat: parseFloat(nrLatitudeCidade),
          lng: parseFloat(nrLongitudeCidade),
        });
        return;
      }

      setLocation({
        lat: result.data.results[0].geometry.location.lat,
        lng: result.data.results[0].geometry.location.lng,
      });
    }
  };

  const handleCreateAddres = async (confirm: boolean) => {
    if (confirm) {
      setOpenConfirmModal(true);
      return;
    }
    try {
      createloading(true);

      addressa.nrLatitude = location.lat;
      addressa.nrLongitude = location.lng;

      const result: ItypeReturnApi =
        await api.apiMaisdelivery.address.createAddress(addressa);

      if (result.data.retorno === 'OK') {
        removeStorege('@mais/delivery/address/create/progress');

        saveStorege('@mais/delivery/address/create/request', {
          id_shop,
          idEndereco: result.data.idEndereco,
          dsEntrega: `${addressa.dsNomeRua} ${addressa.nrNumeroCasa}`,
        });
        if (params && id_shop) {
          toast.success('Endereço cadastrado sucesso, finalize seu pedido');
          handleToPage(`/shop/request/detail/${id_shop}`);
          return;
        }
        toast.success('Endereço cadastrado sucesso');
        if (String(getUser) === '1') {
          handleToPage('/');
          return;
        }
        handleToPage('/dashboard/user/address/list');
      } else {
        toast.error(result.data?.mensagem);
      }
    } catch (error: any) {
      if (error.response.status === 401) {
        signingOut({
          http_status: 401,
          location: 'createAddress',
          id_shop: '',
        });
        toast.info('Sua sessão expirou, por favor faça login novamente');
      } else {
        toast.error(
          'Ocorreu um erro ao cadastrar seu endereço, tente novamente',
        );
      }
    } finally {
      createloading(false);
    }
  };

  useEffect(() => {
    setTextModal({
      title: 'Atenção',
      description:
        'Verifique que o PIN vermelho esteja posicionado correntamente no seu endereço. Caso não esteja, mexa no mapa até posicionar o PIN no seu endereço. No cabeçalho, do lado direito, tem o botão para posicionar o PIN na sua localização via GPS.',
    });
    setOpenInfoModal(true);
  }, []);

  useEffect(() => {
    const resultAddress = getStorege('@mais/delivery/address/create/progress');
    if (resultAddress) {
      getLatLongGoogleMaps(resultAddress);
      setAddressa(resultAddress);
    }
  }, []);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Grid height="100vh">
        <Header children="address" />
        <Grid className={classeStyle.gridButtonLocation}>
          <Button
            className={classeStyle.buttonLocation}
            onClick={() => {
              navigator.geolocation.getCurrentPosition((locationData) => {
                setLocation({
                  lat: locationData.coords.latitude,
                  lng: locationData.coords.longitude,
                });
              });
            }}
          >
            <IconLocation />
          </Button>
        </Grid>

        {addressa && (
          <Grid className={classeStyle.contentDesAddressMap}>
            <Grid className={classeStyle.gridDesAddressMap}>
              <p className={classeStyle.textDesAddressMap}>
                {addressa.dsNomeRua} {addressa.nrNumeroCasa},{' '}
                {addressa.dsCidade}
              </p>
            </Grid>
          </Grid>
        )}
        {isLoaded ? (
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={location}
            zoom={17}
          >
            <MarkerF
              position={location}
              draggable
              onDragEnd={handleNewLocation}
            />
            <></>
          </GoogleMap>
        ) : (
          <></>
        )}
        <Grid container justifyContent="center">
          <Button
            className={classeStyle.btnSubmit}
            style={{
              position: 'fixed',
              bottom: 100,
              width: '80%',
              maxWidth: 680,
            }}
            onClick={() => handleCreateAddres(true)}
            variant="contained"
          >
            Continuar
          </Button>
        </Grid>
      </Grid>
      <FooterMenuMain />
      <Modal
        open={openInfoModal}
        onClose={() => setOpenInfoModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...styleModal, top: '100%', height: '650px!important' }}>
          <Grid container item xs={12} justifyContent="center">
            <IconInfo className={classeStyle.iconModal} />
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              className={classeStyle.titleModal}
              style={{
                fontWeight: '550',
                width: '100%',
                textAlign: 'center',
              }}
            >
              {textModal.title}
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
              className={classeStyle.textModal}
            >
              {textModal.description}
            </Typography>
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Button
              className={classeStyle.btnSubmit}
              style={{ width: '80%' }}
              onClick={() => setOpenInfoModal(false)}
              variant="contained"
            >
              Entendido
            </Button>
          </Grid>
        </Box>
      </Modal>
      <Modal
        open={openConfirmModal}
        onClose={() => setOpenConfirmModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...styleModal, top: '100%', height: '650px!important' }}>
          <Grid container item xs={12} justifyContent="center">
            <IconInfo className={classeStyle.iconModal} />
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              className={classeStyle.titleModal}
              style={{
                fontWeight: '550',
                width: '100%',
                textAlign: 'center',
              }}
            >
              Atenção
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
              className={classeStyle.textModal}
            >
              Você verificou se o PIN vermelho está posicionado corretamente no
              endereço de entrega?
            </Typography>
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Button
              className={classeStyle.btnSubmit}
              style={{ width: '80%' }}
              onClick={() => handleCreateAddres(false)}
              variant="contained"
            >
              Sim
            </Button>
            <Button
              className={classeStyle.btnCloseModal}
              style={{ width: '80%' }}
              onClick={() => setOpenConfirmModal(false)}
              variant="contained"
            >
              Não
            </Button>
          </Grid>
        </Box>
      </Modal>
    </Container>
  );
};

export default AddressMap;
